<template>
	<div class="row principal">
		<div class="col-3 filtros">
			<div class="row">
				<div class="col-12">
					<b-form id="filtrosForm">
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Fecha Desde">
									<date-picker id="fecha_de_desde" name="fecha_de_desde" v-model="fecha_de_desde"
										:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required date>
									</date-picker>
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Fecha Hasta">
									<date-picker id="fecha_de_hasta" name="fecha_de_hasta" v-model="fecha_de_hasta"
										:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required date>
									</date-picker>
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Estado en SII">
									<b-select size="sm" id="estado_en_sii" name="estado_en_sii" v-model="estado_en_sii">
										<b-select-option value=""></b-select-option>
										<b-select-option value="0">Activo</b-select-option>
										<b-select-option value="1">Inactivo</b-select-option>
									</b-select>
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="R.U.T.">
									<b-input size="sm" id="rut" name="rut" regex="^[0-9\-\.kK]{9,12}$" atleast />
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Razón Social">
									<b-input size="sm" id="razon_social" name="razon_social" atleast />
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Folio">
									<b-input size="sm" id="folio" name="folio" type="number" atleast />
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Cliente ID">
									<b-input size="sm" id="cliente_id" name="cliente_id" largo="38" atleast />
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Cliente ID Madre">
									<b-input size="sm" id="cliente_id_madre" name="cliente_id_madre" largo="38" atleast />
								</b-input-group>
							</div>
						</div>
						<p class="separador"></p>
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Tipo Documento">
									<b-select size="sm" id="tipo_documento" name="tipo_documento" v-model="tipo_documento">
										<b-select-option value=""></b-select-option>
										<b-select-option value="15">Factura No Afecta o Exenta</b-select-option>
										<b-select-option value="5">Factura Electrónica</b-select-option>
										<b-select-option value="2">Nota de Crédito</b-select-option>
										<b-select-option value="17">Nota de Débito</b-select-option>
									</b-select>
								</b-input-group>
							</div>
						</div>
						<p></p>
						<div class="row">
							<div class="col-12 text-right">
								<b-button type="button" size="sm" variant="success" @click="buscar()"><i class="fas fa-search fa-fw"></i> Buscar</b-button>
							</div>
						</div>
					</b-form>
				</div>
			</div>
			<p></p>
			<div v-if="validacion != ''" class="row">
				<div class="col-12 text-center"><small>{{ validacion }}</small></div>
			</div>
		</div>
		<div class="col-9">
			<div class="row tabla">
				<div v-if="nodata == false && documentos.length > 0" class="col-12">
					<div class="row">
						<div class="col-3">
							<b-form-input size="sm" v-model="filtro" type="search" id="filterInput" placeholder="Búsqueda"></b-form-input>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-12">
							<b-table striped hover no-border-collapse head-variant="light" :filter="filtro" per-page="10" :current-page="currentPage" :items="getDocumentos" :fields="columnas" show-empty>
								<template #cell(opciones)="data">
									<b-dropdown size="sm" toggle-class="text-decoration-none" text="Action">
										<b-dropdown-item @click="verDOC(data.item.factura_o.urlPDF, data.item.factura_o.company)">Ver PDF</b-dropdown-item>
										<b-dropdown-item @click="verDOC(data.item.factura_o.urlXML, data.item.factura_o.company)">Ver XML</b-dropdown-item>
										<b-dropdown-divider></b-dropdown-divider>
										<b-dropdown-item v-if="data.item.factura_o.tipoDocumento != NC" @click="generarFactura(data.item.factura_o)">Generar Nueva Factura</b-dropdown-item>
										<b-dropdown-item v-if="data.item.factura_o.tipoDocumento != NC" @click="generarNotaCredito(data.item.factura_o)">Generar Nota de Crédito</b-dropdown-item>
										<b-dropdown-divider v-if="data.item.factura_o.tipoDocumento != NC"></b-dropdown-divider>
										<b-dropdown-item>Enviar Mail</b-dropdown-item>
									</b-dropdown>
								</template>
								<template #cell(factura_o.tipoDocumento)="data">
									{{ getBsale(data.value) }}
								</template>
								<template #cell(factura_o.state)="data">
									{{ getState(data.value) }}
								</template>
								<template #cell(factura_o.totalAmount)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(factura_o.emissiondate)="data">
									{{ getFecha(data.value) }}
								</template>
								<template #cell(factura_o.expiration_date)="data">
									{{ getFecha(data.value) }}
								</template>
								<template #cell(factura_o.generation_date)="data">
									{{ getFecha(data.value) }}
								</template>
							</b-table>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-12">
							<b-pagination v-model="currentPage" :total-rows="totalDoctos" per-page="10"></b-pagination>
						</div>
					</div>
				</div>
				<div v-if="nodata" class="col-12">
					<div class="alert alert-primary text-center" role="alert">{{ mensaje }}</div>
				</div>
			</div>
		</div>
		<generar-factura v-if="mostrar_factura" :documento="documento" :on-cerrar="onCerrarFactura" :key="time_factura"></generar-factura>
		<generar-nota-credito v-if="mostrar_nota_credito" :documento="documento" :on-cerrar="onCerrarNotaCredito" :key="time_nota_credito"></generar-nota-credito>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import $ from "jquery"
	import bsale from "./../bsale.json"
	import GenerarFactura from "./generar_factura.vue"
	import GenerarNotaCredito from "./generar_nota_credito.vue"


	export default 
	{
		name: "Refacturacion",
		components: { GenerarFactura, GenerarNotaCredito },
		props: {
			menu: String
		},
		data() {
			return {
				NC: 2,
				flag: true,
				fecha_de_desde: "",
				fecha_de_hasta: "",
				estado_en_sii: "",
				tipo_documento: "",
				documentos: [],
				nodata: false,
				mensaje: "",
				validacion: "",
				filtro: "",
				currentPage: 1,
				columnas: [ 
					{ key: "opciones", label: "Opciones", sortable: false }, 
					{ key: "factura_o.number", label: "Number", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.tipoDocumento", label: "Tipo Documento", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.code", label: "Code", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.company", label: "Company", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.state", label: "State", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.totalAmount", label: "Total Amount", sortable: false, class: "text-nowrap text-right" },
					{ key: "factura_o.emissiondate", label: "Emission Date", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.expiration_date", label: "Expiration Date", sortable: false, class: "text-nowrap" },
					{ key: "factura_o.generation_date", label: "Generation Date", sortable: false, class: "text-nowrap" },
				],
				documento: {},
				time_factura: 0,
				mostrar_factura: false,
				time_nota_credito: 0,
				mostrar_nota_credito: false,
			}
		},
		computed: {

			getDocumentos() {

				return this.filtrar()
			},

			totalDoctos() {

				return this.filtrar().length
			}
		},
		methods: {

			filtrar() {

				return this.documentos.filter((documento) => {

					return documento
				})
			},

			getBsale(id) {

				var name = id 
				bsale.forEach(function(docto) {

					if (docto.codigo == id)
					{
						name = docto.nombre
						return false
					}
				})

				return name
			},

			getState(value) {

				return value == "0" ? "Inactivo" : "Activo"
			},

			getFecha(unix) {

				return moment.unix(unix).utc().format("DD-MM-YYYY")
			},

			verDOC(url, company) {

				var wnd = window.open(url)
				wnd.document.title = company
			},

            buscar() {

				// Guardamos los datos del formulario para validacion
				var form = $("#filtrosForm")[0]
				var data = new FormData(form)

				// Flag que controla la validacion
				var seguir = true 

				// Recorremos todos los campos del formulario para validar que tengan datos
				// Si hay uno que no tenga dato, lo destacamos con un borde rojo (clase is-invalid)
				var that = this
				var params = {}

				var almenos = false
				data.forEach(function(value, key, o) {

					var required = $("#" + key).attr("required")
					if (required != undefined && value == "") {

						$("#" + key).addClass("is-invalid")
						seguir = false
					} else 
						$("#" + key).removeClass("is-invalid")

					var regex = $("#" + key).attr("regex");
					if (required != undefined && regex != undefined && regex != "")
					{
						var pattern = new RegExp(regex, "g")
						var flag = pattern.test(value.toString())

						if (!flag) {

							$("#" + key).addClass("is-invalid")
							seguir = false
						} else
							$("#" + key).removeClass("is-invalid")
					}

					// Si el campo tiene validacion de largo, revisamos aqui
					var largo = $("#" + key).attr("largo")
					if (largo != undefined && value != "" && value.toString().length < largo)
					{
						$("#" + key).addClass("is-invalid")

						seguir = false
					}

					var atleast = $("#" + key).attr("atleast")
					if (atleast != undefined && value != "")
						almenos = true

					// Agregamos un asterisco a los campos sin valor y a los que tienen valor (al final del texto)
					var date = $("#" + key).attr("date")
					if (date === undefined)
						value += "*"

					if (seguir)
						params[key] = value
				})

				if (!almenos) {

					data.forEach(function(value, key, o) {

						var atleast = $("#" + key).attr("atleast")
						if (atleast != undefined)
							$("#" + key).addClass("is-invalid")
					})

					this.validacion = "Debe ingresar RUT o Razón Social o Folio o Cliente ID o Cliente ID Madre"
					seguir = false
				} else
					this.validacion = ""

				if (!seguir)
					return;

				// Actualizamos el formato del RUT (quitamos los puntos y pasamos a mayuscula el DV)
				var rut = params["rut"]
				rut = rut.replaceAll(".", "").toUpperCase()

				// Validamos que el rut traiga guión. Si no lo trae, lo agregamos
				if (rut != "*")
				{
					var pos = rut.indexOf("-")
					if (pos < 0)
						rut = rut.substr(0, rut.length - 2) + "-" + rut.substr(rut.length - 2, 2)
					params["rut"] = rut
				}


				// Parseamos las fechas para convertirla a epoch
				var tmp = this.fecha_de_desde.split("/")
				var fecha = tmp[2] + "-" + tmp[1] + "-" + tmp[0] + "T00:00:00+00:00"
				params["fecha_de_desde"] = moment(fecha).format("X")

				tmp = this.fecha_de_hasta.split("/")
				fecha = tmp[2] + "-" + tmp[1] + "-" + tmp[0] + "T00:00:00+00:00"
				params["fecha_de_hasta"] = moment(fecha).unix()

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

                // Llamamos al WS para traer las fichas a mostrar
				var request = { 
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "D0", 
					"operacion": "seekDTE", 
					"data2Query": params
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					var data = response.data
					if (data.mensaje_error !== undefined) {

						this.nodata = true
						this.mensaje = data.mensaje_error
					} else {

						this.nodata = false
						this.mensaje = ""
						this.documentos = response.data.data
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
            },

			generarFactura(data) {

				this.time_factura = Date.now()
				this.documento = data
				this.mostrar_factura = true
			},

			generarNotaCredito(data) {

				this.time_nota_credito = Date.now()
				this.documento = data
				this.mostrar_nota_credito = true
			},

			// Para cerrar la ventana de Refacturacion
			onCerrarFactura() {

				this.time_factura = Date.now()
				this.mostrar_factura = false 
			},

			// Para cerrar la ventana de Refacturacion
			onCerrarNotaCredito() {

				this.time_nota_credito = Date.now()
				this.mostrar_nota_credito = false 
			},
		}
	}

</script>
<style scoped>

	.principal {
		width: 100%;
		height: 560px;
		margin: 0 !important;
	}

	.separador {
		margin-bottom: 8px;
	}

	.filtros {
        width: 100%;
		height: 100%;
		padding: 10px;
	}

    .tabla {
		height: 98%;
        overflow: auto;
        background-color: white;
		padding: 10px 0px 10px 0px;
		margin-top: 10px !important;
		margin-right: -5px !important;
    }

</style>
